import { render, staticRenderFns } from "./OrderSearchCustom.vue?vue&type=template&id=87fd76c4&"
import script from "./OrderSearchCustom.vue?vue&type=script&lang=ts&"
export * from "./OrderSearchCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports